import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import {
  getCoevaluationsHomework,
  getHomework,
  getListCoevaluationItems
} from 'store/lesson-actions';

import Loading from 'components/UI/Loading/Loading';
import NotActivity from './NotActivity/NotActivity';
import UserActivity from './UserActivity/UserActivity';

const Activity = props => {
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();
  const dataLesson = useSelector(state => state.lessonInfo);

  useEffect(() => {
    dispatch(getHomework(props.idLesson));
    dispatch(getCoevaluationsHomework(props.idLesson));
    if (!dataLesson.coevaluationsItems) {
      dispatch(getListCoevaluationItems(props.idLesson));
    }
  }, [props.idLesson]);

  useEffect(() => {
    if (dataLesson.homework) {
      setIsLoading(false);
    }
  }, [dataLesson.homework]);

  return (
    <>
      {!isLoading ? (
        <>
          {dataLesson.homework.idUserHomework !== 0 ? (
            <UserActivity />
          ) : (
            <NotActivity
              changeHomeworkStatus={props.changeHomeworkStatus}
              returnVideo={props.returnVideo}
              idLesson={props.idLesson}
            />
          )}
        </>
      ) : (
        <Loading />
      )}
    </>
  );
};

Activity.propTypes = {
  // eslint-disable-next-line react/require-default-props
  idCourse: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  idLesson: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  returnVideo: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  changeHomeworkStatus: PropTypes.func
};

export default Activity;
